import React from 'react';
import ReactDOM from 'react-dom';
import App from './js/App';
import store from './js/redux/store';
import { Provider } from 'react-redux';
import {
  createMuiTheme,
  responsiveFontSizes,
  ThemeProvider,
} from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { isMobile } from 'react-device-detect';

const lightTheme = true;
const options = {
  palette: {
    type: lightTheme ? 'light' : 'dark',
    background: {
      paper: lightTheme ? '#f5f5f5' : '#424242',
      default: lightTheme ? '#ffffff' : '#424242',
      primary: lightTheme ? '#0d479d' : '#0d479d',
    },
    primary: {
      main: '#0d47a1',
      // dark: '#ff0000;',
    },
    secondary: {
      light: '#f5f5f5',
      main: '#f5f5f5',
      //dark: '#424242;',
      // dark: '#ff0000;',
      contrastText: '#000',
    },
  },
};
const desktopOptions = options;
// const mobileOptions = { ...options, typography: { fontSize: '24' } };
const mobileOptions = options;
const theme = createMuiTheme(isMobile ? mobileOptions : desktopOptions);
const rtheme = responsiveFontSizes(theme);

//Required Import to ensure auth.html gets deployed as simple HTML file.
//Even though auth isn't referenced in this file the below import must remain
import auth from './auth.html';
//Authentication
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './js/redux/authConfig';
import { PublicClientApplication } from '@azure/msal-browser';

const pca = new PublicClientApplication(msalConfig);
ReactDOM.render(
  <ThemeProvider theme={rtheme}>
    <CssBaseline />
    <Provider store={store}>
      <MsalProvider instance={pca}>
        <App />
      </MsalProvider>
    </Provider>
  </ThemeProvider>,
  document.getElementById('root')
);
